'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callApiMiddleware = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _middleware = require('ifeis-isomorphic/lib/redux/middleware');

// A Redux middleware that interprets actions with CALL_API info specified.
// Performs the call and promises when such actions are dispatched.
var callApiMiddleware = exports.callApiMiddleware = function callApiMiddleware($http) {
  return function (store) {
    return function (next) {
      return function (action) {
        var api = action[_middleware.CALL_API];

        if (!api) {
          return next(action);
        }

        var config = api.config,
            types = api.types;

        var _types = _slicedToArray(types, 3),
            requestType = _types[0],
            successType = _types[1],
            failureType = _types[2];

        var actionWith = function actionWith(data) {
          var finalAction = _extends({}, action, data);

          delete finalAction[_middleware.CALL_API];

          return finalAction;
        };

        next(actionWith({ type: requestType }));

        return $http(config).then(function (payload) {
          return store.dispatch(actionWith({ type: successType, payload: payload }));
        }).catch(function (errors) {
          return store.dispatch(actionWith({ type: failureType, errors: errors }));
        });
      };
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./middleware/index.js
// module id = 454
// module chunks = 0